import { Drawer as MUIDrawer, DrawerProps } from '@mui/material';

export { type DrawerProps } from '@mui/material';

export function Drawer(props: DrawerProps) {
  return <MUIDrawer {...props} />;
}
